import * as React from 'react';
import { Card, Col, Row, Typography } from 'antd';
const { Text } = Typography;
import './CaptchaInputWrapper.scss';
import { ReloadOutlined } from '@ant-design/icons';

export interface CaptchaInputWrapperProps {
  children: React.ReactNode;
}

/**
 * Contenitore per l'input del widget Captcha
 * Include gli stili e il testo descrittivo
 */
export function CaptchaInputWrapper(props: CaptchaInputWrapperProps) {
  return (
    <Card size="small" className="captcha-widget-wrapper">
      <Row>
        <Col>
          <Text type="secondary">
            Inserisci il codice mostrato nel riquadro prima di inviare il
            modello.
          </Text>
        </Col>
      </Row>
      <Row align="middle" gutter={24}>
        {props.children}
      </Row>
      <Row>
        <Col>
          <Text type="secondary">
            Premi sul pulsante <ReloadOutlined /> per generare un nuovo codice.
          </Text>
        </Col>
      </Row>
    </Card>
  );
}
